import type { TokenColor } from "../types.ts";

export const BACKGROUND = "#0f172a";
export const CELL_BG = "#1e293b";
export const GRID_LINE = "#334155";
export const WALL_COLOR = "#e2e8f0";
export const HOLE_COLOR = "#0a0a1a";
export const HOLE_RING = "#4a1a2a";

export const TOKEN_FILLS: Record<TokenColor, string> = {
  red: "#ef4444",
  blue: "#3b82f6",
  green: "#22c55e",
  yellow: "#eab308",
};

export const TOKEN_STROKES: Record<TokenColor, string> = {
  red: "#b91c1c",
  blue: "#1d4ed8",
  green: "#15803d",
  yellow: "#a16207",
};

export const GOAL_FILLS: Record<TokenColor, string> = {
  red: "#ef444425",
  blue: "#3b82f625",
  green: "#22c55e25",
  yellow: "#eab30825",
};

export const GOAL_BORDERS: Record<TokenColor, string> = {
  red: "#ef4444",
  blue: "#3b82f6",
  green: "#22c55e",
  yellow: "#eab308",
};

export const TELEPORTER_COLORS = ["#c084fc", "#fb923c"];
